export enum GlobalVendorListVersion {
    V3 = 3
}
